import { apiBaseURL } from "../ProjectConstants";

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    id: int,
    location: str,
*/
async function handlePutSupplierList(locationData, fetch) {
  const body = {
    id: locationData.id,
    location: locationData.location,
  };

  const response = await fetch.put(
    `${apiBaseURL}/api/supplier`,
    body
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePutSupplierList", body);
  console.log("handlePutSupplierList response", response);

  return {
    response,
    isDataGood,
  };
}
export default handlePutSupplierList;
